<ng-container *transloco="let t">
  @if (fullPage()) {
    <div
      id="loading-spinner-overlay"
      class="fixed inset-0 bg-white/80 z-9999 flex flex-col items-center justify-center gap-4"
      role="status"
      aria-live="polite"
    >
      <mat-spinner [diameter]="diameter()" [class]="colorClass()" />

      @if (message()) {
        <p id="loading-spinner-message" class="font-dm text-base text-ld-neutral">
          {{ message() }}
        </p>
      }

      <span class="sr-only">{{ t('commonLabelsLoading') }}</span>
    </div>
  } @else {
    <div id="loading-spinner-inline" class="inline-flex items-center gap-2" role="status" aria-live="polite">
      <mat-spinner [diameter]="diameter()" [class]="colorClass()" />

      @if (message()) {
        <span id="loading-spinner-inline-message" class="font-dm text-sm text-ld-neutral">
          {{ message() }}
        </span>
      }

      <span class="sr-only">{{ t('commonLabelsLoading') }}</span>
    </div>
  }
</ng-container>
